/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Clear_ReadInputs */

const en_notifications_clear_read = /** @type {(inputs: Notifications_Clear_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear read`)
};

const pt_br2_notifications_clear_read = /** @type {(inputs: Notifications_Clear_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar lidas`)
};

/**
* | output |
* | --- |
* | "Clear read" |
*
* @param {Notifications_Clear_ReadInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_clear_read = /** @type {((inputs?: Notifications_Clear_ReadInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Clear_ReadInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_clear_read(inputs)
	return pt_br2_notifications_clear_read(inputs)
});